import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";

import { i18n, api } from "services";
import { configure as configureStore } from "store";
import Routes from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "swiper/swiper.scss";
import "assets/styles/bootstrap-grid.min.css";
import "assets/styles/main.scss";
import "assets/styles/fonts.css";
import "assets/styles/style.scss";
import "assets/styles/normalize.css";

const store = configureStore();
api.subscribe(store);
store.subscribe(() => {
  api.subscribe(store);
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      retry: false,
    },
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Suspense fallback="">
        <I18nextProvider i18n={i18n()}>
          <Routes store={store} />
        </I18nextProvider>
      </Suspense>
    </Provider>
  </QueryClientProvider>
);
